export default __webpack_public_path__ + "static/media/Camera.68ff06a2.png";